// Common
import { ReactElement } from 'react'

// Styles
import { makeStyles } from '@material-ui/styles'

// Icons
import { SvgIcon } from '@material-ui/core'
import { SvgIconProps } from '@material-ui/core/SvgIcon'

const useStyle = makeStyles({
	root: {
		'& path': {
			transition: 'fill .2s ease',
		},
	},
})

function DoneIcon(props: SvgIconProps): ReactElement {
	const classes = useStyle()
	return (
		<SvgIcon className={classes.root} width="74" height="74" viewBox="0 0 74 74" {...props}>
			<path d="M37.0003 0.000395036C57.4347 0.000395036 74.0002 16.5659 74.0002 37.0003C74.0002 57.4347 57.4347 74.0002 37.0003 74.0002C16.5659 74.0002 0.000397612 57.4347 0.000397612 37.0003C-0.0577473 16.6238 16.4134 0.05854 36.7896 0.000395036C36.8599 0.000193842 36.9301 0.000193842 37.0003 0.000395036Z" fill="#73C21E"/>
			<path d="M57.4974 26.804L31.2191 53.0823L16.5032 38.4717L22.4947 32.5853L31.2191 41.2047L51.506 20.9177L57.4974 26.804Z" fill="white"/>
		</SvgIcon>
	)
}

export default DoneIcon
